import { render, staticRenderFns } from "./promotionAdd.vue?vue&type=template&id=9ad1c118&"
import script from "./promotionAdd.vue?vue&type=script&lang=js&"
export * from "./promotionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports